export const STAGE_KEY = 'brand';

export const STAGE_CONFIG = {
  id: 'fase1',
  label: 'Analisis de Negocio y Marca',
  questionOrder: [
    'userName',
    'businessType',
    'negocio',
    'offer',
    'isBusinessOnline',
    'hasOnlineSales',
    'missingAssets',
    'hasGoogleMyBusiness',
    'knowsTargetService',
    'priorityOffering',
    'targetAudience',
    'objetivoPrincipal',
    'brandStatus',
    'brandVision',
    'expectedOutcome',
    'presupuestoMesa',
    'desiredTimeline',
    'userEmail',
    'userPhone',
  ],
  coreFields: [
    'userName',
    'businessType',
    'negocio',
    'isBusinessOnline',
    'offer',
    'objetivoPrincipal',
    'userEmail',
    'userPhone',
  ],
  serviceIds: [
    'marca-investigacion',
    'marca-arquitectura',
    'marca-branding',
    'marca-web',
    'marca-redes',
  ],
  questions: {
    userName: '¡Hola! Es un gusto saludarle. Soy {activePersonaName}, su asesor especializado de Hitpoly. Antes de comenzar, ¿con quién tengo el gusto de hablar?',
    businessType: '¡Mucho gusto, {userName}! Para entender mejor el contexto, ¿es usted una empresa ya constituida o trabaja como profesional independiente?',
    negocio: 'Entiendo perfectamente. ¿Cómo se llama su marca, negocio o el proyecto que tiene en mente?',
    isBusinessOnline: '¿Y actualmente su negocio ya tiene presencia en internet (web o redes) o estamos partiendo totalmente de cero?',
    hasOnlineSales: '¿Y hoy en día ya logra captar ventas o clientes directamente desde internet o es algo que todavía le cuesta?',
    userEmail: 'Perfecto. Por seguridad y para enviarle su analisis detallado una vez terminemos, ¿me podria indicar su correo electronico?',
    userPhone: 'Gracias. ¿Me podria facilitar tambien su WhatsApp o numero de contacto? Asi podremos estar comunicados si se pierde la conexion durante esta asesoria.',
    missingAssets: 'Para trazar el camino correcto, ¿que siente que le falta crear hoy? (Pagina web, Branding, Redes sociales como FB, IG, LinkedIn o TikTok...) puede mencionarme lo que no tenga listo.',
    hasGoogleMyBusiness: '¿Y cuenta ya con su ficha de Google My Business (el mapa en Google) habilitada y activa?',
    offer: 'Hablemos de lo que ofrece: ¿Vende productos o servicios? ¿Podria describirme brevemente su oferta principal?',
    priorityOffering: 'De todo eso, ¿cual es el producto o servicio que mas le interesa impulsar o vender ahora mismo?',
    targetAudience: '¿A que publico busca atacar? ¿Cual es su cliente ideal hoy?',
    objetivoPrincipal: 'Finalmente, ¿que espera lograr con nuestros servicios? ¿Busca reconocimiento de marca, mas ventas directas, publicidad o algun otro objetivo especifico?',
  },
};

const brandGuide = {
  role: 'Asesor de creacion de marca y salida al mercado.',
  detectWhen: [
    'El negocio aun no esta montado o se esta armando.',
    'Faltan web, logo, redes, brochure, identidad o materiales base.',
    'El usuario dice que quiere crear marca, salir al mercado, verse mas serio o diferenciarse.',
  ],
  firstQuestions: [
    'Que servicio puntual busca activar ahora: branding, web, redes, brochure, spots, algo mas?',
    'Cuales son los activos que siente que le faltan crear hoy?',
  ],
  thenAsk: [
    'Que idea de marca tiene en mente (moderna, premium, cercana, etc.)?',
    'Que espera tener al terminar esta etapa para decir que valio la pena?',
    'Con cuanto presupuesto real cuenta para construir esta base?',
    'En cuanto tiempo quiere salir listo al mercado?',
  ],
  avoidForNow: [
    'No preguntes CPL, tasa de cierre o ROI de campanas como eje principal.',
    'No empujes ventas o conversion si aun no existe la base de marca.',
  ],
  mustExplain: [
    'La marca es la maquina base que luego soporta atraccion, nutricion y conversion.',
    'Aqui se construyen activos tangibles: logo, web, redes, narrativa, brochure, spots, analitica y blog inicial.',
  ],
  services: [
    'Investigacion de mercado',
    'Propuesta de valor y arquitectura de mensajes',
    'Branding visual y mensajes base',
    'Pagina web comercial inicial',
    'Configuracion inicial de redes sociales',
    'Brochure y diapositivas comerciales',
    'Spots publicitarios iniciales',
    'Sincronizacion con analitica',
    'Articulos iniciales del blog',
  ],
};

export default brandGuide;
